import {DeviceType} from '@/types/device/DeviceType'
import {DeviceGroup} from '@/models/DeviceGroup'
import {PowerPacket} from '@/models/PowerPacket'
import {Prettify} from '@/utils/Prettify'
import {DeviceStatus, STATUS_ALERT, STATUS_NOT_AVAILABLE, STATUS_OK, STATUS_WARNING} from '@/types/device/DeviceStatus'
import {DetectorPacket} from '@/models/DetectorPacket'

export interface Device
{
    id: number
    name: string
    type?: DeviceType
    typeLabel?: string
    groupId?: number
    code: string
    group?: DeviceGroup
    lastPowerPacket?: PowerPacket
    lastDetectorPacket?: DetectorPacket
    state?: string
    stateLabel?: string
    posX: number
    posY: number
    status?: DeviceStatus
    timeout?: number
    // todo: change to specific type
    linkType: string
    linkTypeLabel?: string
    isHidden: boolean
    isEmitting?: boolean
    actionRadiusMeters?: number
}

export type DeviceDraft = Prettify<Partial<Device> & {
    name: string
    posX: number
    posY: number
    linkType: string
    code: string
    isHidden: boolean
}>

export function createDevice(): DeviceDraft {
    return {
        id: undefined,
        name: '',
        posX: 0,
        posY: 0,
        type: undefined,
        linkType: 'no-link',
        groupId: undefined,
        code: '',
        isHidden: false,
        actionRadiusMeters: undefined,
    }
}

export function getDeviceIconUrl(device: Device): string {
    let prefix = 'round'
    if (device.type === 'detector') {
        prefix = 'triangle'
    }

    if (device.status === STATUS_OK) {
        return `/icons/${prefix}-green.png`
    } else if (device.status === STATUS_WARNING) {
        return `/icons/${prefix}-yellow.png`
    } else if (device.status === STATUS_ALERT) {
        return `/icons/${prefix}-red.png`
    } else if (device.status === STATUS_NOT_AVAILABLE) {
        return `/icons/${prefix}-green.png`
    }

    return ''
}

export function doesDeviceHasState(device: Device): boolean {
    return device.state != null
        || device.status !== STATUS_NOT_AVAILABLE
        || device.lastPowerPacket != null
        || device.lastDetectorPacket != null
}

export function isDeviceEmitter(device: Device): boolean {
    return device.type !== 'detector'
}

export function isDeviceDetector(device: Device): boolean {
    return device.type === 'detector'
}